<template>
  <div>
    <q-layout class="altura-minima" view="hHh Lpr lFf">
      <q-header v-if="$store.state.pdt.header" elevated>
        <q-toolbar class="bg-brand-1">
          <q-btn
            flat
            dense
            round
            @click="leftDrawerOpen = !leftDrawerOpen"
            aria-label="Menu"
            icon="menu"
            class="btn-menu-aba"
          />

          <q-toolbar-title
            class="pointer imagem-logo flex items-center"
            @click="getInico"
          >
            <q-img
              v-if="
                $store.state.autenticacao.logo &&
                $store.state.autenticacao.logo.logo
              "
              width="152px"
              height="38px"
              class="q-ml-md logo-ajustada"
              :src="$store.state.autenticacao.logo.logo"
            />
            <q-img
              v-else
              width="152px"
              height="38px"
              class="logo-ajustada"
              src="../assets/MULTPEX_LOGO.png"
            />
          </q-toolbar-title>

          <!-- Base de Conhecimento - Responsivo -->
          <q-btn
            href="https://sites.google.com/multpex.com.br/basedeconhecimento/in%C3%ADcio"
            target="blank"
            icon="help"
            :label="$q.screen.gt.sm ? 'Base de Conhecimento' : ''"
            flat
            :class="$q.screen.gt.sm ? 'help' : ''"
          >
            <q-tooltip>Base de Conhecimento</q-tooltip>
          </q-btn>

          <!-- Assistente IA - Responsivo -->
          <q-btn
            @click="getButtonsHeader('fale-com-a-ia')"
            icon="smart_toy"
            :label="$q.screen.gt.sm ? 'Assistente IA' : ''"
            flat
          >
            <q-tooltip>Converse com nosso assistente inteligente</q-tooltip>
          </q-btn>

          <!-- Novidades - Responsivo -->
          <q-btn
            @click="verNovidades"
            icon="campaign"
            :label="$q.screen.gt.sm ? 'Novidades' : ''"
            flat
          >
            <q-tooltip>Ver novidades e comunicados</q-tooltip>
          </q-btn>

          <!-- WhatsApp Atendimento - Responsivo -->
          <q-btn
            size="sm"
            flat
            target="blank"
            href="https://wa.me/5511930315382"
          >
            <div class="row no-wrap items-center">
              <q-icon size="sm" class="text-dark">
                <img
                  src="../assets/whatsapp.png"
                  style="width: 17.14px; height: 17.14px"
                />
              </q-icon>
              <div v-if="$q.screen.gt.sm" class="q-ml-xs">
                Atendimento Multpex
              </div>
            </div>
            <q-tooltip>Atendimento Multpex</q-tooltip>
          </q-btn>

          <!-- Central de Download - Responsivo -->
          <q-btn
            @click="getButtonsHeader('central-downloads-tabela')"
            icon="cloud_download"
            :label="$q.screen.gt.sm ? 'Central de Download' : ''"
            flat
            size="sm"
          >
            <q-tooltip>Central de Download</q-tooltip>
          </q-btn>

          <q-btn flat round size="sm" class="q-mr-lg no-mobile self-center">
            <q-tooltip> Deslogar </q-tooltip>
            <q-avatar
              size="sm"
              icon="logout"
              color="brand-1"
              text-color="brand-10"
              @click="efetuarLogout"
              class="flex items-center"
            ></q-avatar>
          </q-btn>

          <div class="column titulos">
            <div>
              <span
                class="row col-12 justify-end text-h5 text-brand-10 text-weight-bolder"
                >MULTPEX</span
              >
            </div>
            <div class="row">
              <span class="row text-caption text-brand-10 text-right q-mr-sm"
                >{{
                  usuarioLogado && usuarioLogado.nome
                    ? usuarioLogado.nome
                    : "Offline"
                }}
              </span>
              <div
                v-if="
                  $store.state.autenticacao.listaPerfis &&
                  $store.state.autenticacao.listaPerfis.length > 0
                "
                class="row text-caption text-brand-10 text-right items-center"
              >
                <span> Perfis: {{ perfisExibidos.join(" | ") }} </span>
                <q-btn
                  v-if="$store.state.autenticacao.listaPerfis.length > 3"
                  flat
                  dense
                  round
                  size="xs"
                  icon="add"
                  class="q-ml-xs text-brand-10"
                  style="min-width: 20px; width: 20px; height: 20px"
                >
                  <q-tooltip>
                    <div>
                      <div class="text-weight-bold q-mb-xs">
                        Todos os perfis:
                      </div>
                      <div>
                        {{ $store.state.autenticacao.listaPerfis.join(" | ") }}
                      </div>
                    </div>
                  </q-tooltip>
                </q-btn>
              </div>
              <!-- Fallback para o perfil único se não houver lista de perfis -->
              <span
                v-else-if="$store.state.autenticacao.perfil"
                class="row text-caption text-brand-10 text-right"
                >Perfil: {{ $store.state.autenticacao.perfil }}</span
              >
            </div>
          </div>

          <q-btn
            class="no-mobile self-center"
            @click="getNotificacoes"
            round
            color="white text-indigo"
          >
            {{
              usuarioLogado && usuarioLogado.primeiraLetraNome
                ? usuarioLogado.primeiraLetraNome
                : "F"
            }}
            <q-badge floating color="red" rounded>{{
              $store.state.autenticacao.notificacoesNovas
            }}</q-badge>
          </q-btn>

          <q-btn round color="white text-indigo" class="no-desktop self-center">
            {{
              usuarioLogado && usuarioLogado.primeiraLetraNome
                ? usuarioLogado.primeiraLetraNome
                : "F"
            }}
            <q-badge floating color="red" rounded>{{
              $store.state.autenticacao.notificacoesNovas
            }}</q-badge>
            <q-menu>
              <q-list style="min-width: 150px">
                <q-item @click="getNotificacoes" clickable v-close-popup>
                  <q-item-section>
                    <span class="row col-12 items-center">
                      <q-icon
                        class="q-mr-xs"
                        size="14px"
                        name="notifications"
                      />
                      <span>Notificações</span>
                    </span>
                  </q-item-section>
                </q-item>
                <q-item @click="efetuarLogout" clickable v-close-popup>
                  <q-item-section>
                    <span class="row col-12 items-center">
                      <q-icon class="q-mr-xs" size="14px" name="logout" />
                      <span>Sair</span>
                    </span>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </q-toolbar>

        <div v-if="menu" class="separador"></div>

        <q-tabs
          v-if="menu"
          v-model="tab"
          inline-label
          no-caps
          align="left"
          indicator-color="brand-3"
          class="bg-brand-2 text-brand-9 shadow-2"
        >
          <q-tab
            @click="transferir('home')"
            name="home"
            icon="home"
            label="Página inicial"
          />
          <div
            v-show="
              $store.state.autenticacao.perfil != undefined &&
              $store.state.autenticacao.perfil != null
            "
            v-for="(menuItem, index) in favoritos"
            :key="index"
          >
            <q-tab
              v-if="menuItem.ativo"
              :name="menuItem.name"
              :label="menuItem.label"
              :icon="menuItem.icon"
              @click="transferir(menuItem.name)"
            />
          </div>
        </q-tabs>
      </q-header>

      <q-drawer
        v-if="$store.state.pdt.header && menu"
        v-model="leftDrawerOpen"
        class="bg-white"
        :width="mobile ? 320 : 350"
      >
        <q-list dense class="q-ma-sm">
          <q-item-label dense header>
            <q-input
              rounded
              outlined
              dense
              type="text"
              class="col-md-3 col-xs-12"
              placeholder="Pesquisar"
              v-model="filtro"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </q-item-label>

          <menu-aba
            :menuList="menuLista"
            :tabSubmenu="tabSubmenu"
            @atualizar="getTab"
          ></menu-aba>
        </q-list>
      </q-drawer>

      <q-page-container>
        <!-- <Breadcrumbs v-if="$store.state.pdt.header" /> -->
        <router-view class="altura-minima"></router-view>
      </q-page-container>
      <basic-dialog></basic-dialog>
      <aviso-treinamento-modal
        v-model="avisoTreinamentoAberto"
        :user-email="usuarioLogado?.email || ''"
        :doc-id="avisoTreinamentoDocId"
        :user-sap="avisoTreinamentoUserSap"
        :user-name="avisoTreinamentoUserName"
        :tipo-treinamento-web="avisoTreinamentoTipoTreinamentoWeb"
      />
      <aviso-treinamento-calendario-vencido-modal
        v-model="avisoTreinamentoCalendarioVencidoAberto"
        :user-email="usuarioLogado?.email || ''"
        :doc-id="avisoTreinamentoCalendarioVencidoDocId"
        :user-sap="avisoTreinamentoCalendarioVencidoUserSap"
        :user-name="avisoTreinamentoCalendarioVencidoUserName"
        :tipo-treinamento-web="
          avisoTreinamentoCalendarioVencidoTipoTreinamentoWeb
        "
      />
      <aviso-treinamento-videos-vencido-modal
        v-model="avisoTreinamentoVideosVencidoAberto"
        :user-email="usuarioLogado?.email || ''"
        :doc-id="avisoTreinamentoVideosVencidoDocId"
        :user-sap="avisoTreinamentoVideosVencidoUserSap"
        :user-name="avisoTreinamentoVideosVencidoUserName"
        :tipo-treinamento-web="avisoTreinamentoVideosVencidoTipoTreinamentoWeb"
      />
    </q-layout>
    <span class="version-alert text-weight-bold"
      >Versão: {{ versaoAtual }}</span
    >
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
//import LocaleChange from "../components/locale/LocaleChange.vue";
import { fetchAppVersion } from "@/composables/useVersionCheck";
import routes from "@/router/routes";
import { useRouter, useRoute } from "vue-router";
import { bannerService } from "@/modules/banners";
import { useQuasar } from "quasar";

// import Breadcrumbs from "@/components/menu/Breadcrumbs.vue";

import { useStore } from "vuex";
import { onMounted, computed, inject, watch } from "vue";
import BasicDialog from "../components/BasicDialog.vue";
import MenuAba from "../components/menu/MenuAba.vue";
import AvisoTreinamentoModal from "../components/AvisoTreinamentoModal.vue";
import AvisoTreinamentoCalendarioVencidoModal from "../components/AvisoTreinamentoCalendarioVencidoModal.vue";
import AvisoTreinamentoVideosVencidoModal from "../components/AvisoTreinamentoVideosVencidoModal.vue";
import { avisoTreinamentoService } from "../services/avisoTreinamentoService";

export default {
  name: "LayoutDashboardTeste",
  components: {
    //LocaleChange,

    BasicDialog,
    MenuAba,
    AvisoTreinamentoModal,
    AvisoTreinamentoCalendarioVencidoModal,
    AvisoTreinamentoVideosVencidoModal,

    // Breadcrumbs,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const myTimeout = ref(null);
    const menuSearchTimeout = ref(null);
    const routerChildren = ref([]);
    const menu = ref(true);
    const realm = ref("");
    const $q = useQuasar();
    let leftDrawerOpen = ref(true);
    const menuList = ref([]);
    const favoritos = ref([]);
    const filtro = ref("");
    const menuLista = ref([]);
    const tabSubmenu = ref("");
    const menuListaTotal = ref([]);

    let mobile = ref(false);

    if ($q.platform.is.mobile) {
      leftDrawerOpen = ref(false);
      mobile.value = true;
    }

    let toggleLeftDrawerOpen = () => {
      leftDrawerOpen = !leftDrawerOpen;
    };
    const tab = ref("");
    const versaoAtual = ref("--");

    const store = useStore();
    const keycloak = inject("keycloak");
    const avisoTreinamentoAberto = ref(false);
    const avisoTreinamentoDocId = ref(null);
    const avisoTreinamentoUserSap = ref(null);
    const avisoTreinamentoUserName = ref(null);
    const avisoTreinamentoTipoTreinamentoWeb = ref(null);
    const avisoTreinamentoCalendarioVencidoAberto = ref(false);
    const avisoTreinamentoCalendarioVencidoDocId = ref(null);
    const avisoTreinamentoCalendarioVencidoUserSap = ref(null);
    const avisoTreinamentoCalendarioVencidoUserName = ref(null);
    const avisoTreinamentoCalendarioVencidoTipoTreinamentoWeb = ref(null);
    const avisoTreinamentoVideosVencidoAberto = ref(false);
    const avisoTreinamentoVideosVencidoDocId = ref(null);
    const avisoTreinamentoVideosVencidoUserSap = ref(null);
    const avisoTreinamentoVideosVencidoUserName = ref(null);
    const avisoTreinamentoVideosVencidoTipoTreinamentoWeb = ref(null);

    let usuarioLogado = computed(
      () => store.getters["autenticacao/usuarioLogado"]
    );

    const efetuarLogout = () => {
      store.dispatch("autenticacao/logout");
      keycloak.logout({ redirectUri: window.location.origin });
    };

    const verNovidades = () => {
      try {
        // Resetar banners fechados
        bannerService.clearAllClosedBanners();

        // Verificar se já estamos na home
        const isOnHome = route.name === "home";

        if (isOnHome) {
          // Se já estamos na home, emitir evento para recarregar banners
          window.dispatchEvent(new CustomEvent("banner-reset"));

          $q.notify({
            message: "Novidades disponíveis!",
            color: "positive",
            icon: "campaign",
            position: "top",
            timeout: 2000,
          });
        } else {
          // Se não estamos na home, notificar e redirecionar
          $q.notify({
            message:
              "Novidades disponíveis! Redirecionando para a página inicial...",
            color: "positive",
            icon: "campaign",
            position: "top",
            timeout: 2000,
          });

          // Redirecionar para a home após um breve delay
          setTimeout(() => {
            router.push({ name: "home" });
          }, 1000);
        }
      } catch (error) {
        console.error("Erro ao ver novidades:", error);
        $q.notify({
          message: "Erro inesperado. Tente novamente.",
          color: "negative",
          icon: "error",
          position: "top",
          timeout: 3000,
        });
      }
    };

    watch(
      () => route.name,
      () => {
        //filtro.value = "";
        if (route.name == "home") {
          menu.value = true;
        } else {
          menu.value = true;
          tab.value = route.name;
          verificarSubmenuPai();
        }
        getTab();
      }
    );

    watch(
      () => route.name,
      () => {
        if (route.path.indexOf("relatorio") != -1) {
          leftDrawerOpen.value = false;
        }
      }
    );

    const getRelatorioCheck = async () => {
      if (route.path.indexOf("relatorio") != -1) {
        leftDrawerOpen.value = false;
      }
    };

    const getTab = async () => {
      if (menuListaTotal.value.length === 0) {
        return;
      }
      let arrayFavoritos = localStorage.getItem("favoritos");
      tab.value = route.name;
      if (arrayFavoritos) {
        favoritos.value = JSON.parse(arrayFavoritos);
        favoritos.value.forEach((f) => {
          menuListaTotal.value.forEach((menu) => {
            if (menu?.submenu?.paginas.length > 0) {
              menu?.submenu?.paginas.forEach((menuFilho) => {
                let resultado = false;
                if (resultado) {
                  return;
                }
                if (menuFilho?.nome == f?.name) {
                  f.ativo = true;
                  menuFilho.favorite = true;
                }
              });
            }
          });
        });
      }
      if (route.name == "home") {
        menu.value = true;
      }
    };

    const verificarSubmenuPai = async () => {
      if (route.name === "home") {
        return;
      }

      if (menuLista.value.length == 0 || menuLista.value === undefined) {
        return;
      }
      for (const item of menuLista.value) {
        let menuPai = item.submenu.paginas.find(
          (pagina) => pagina.nome === route.name
        );
        if (menuPai != undefined) {
          tabSubmenu.value = item.submenu.nomeVisualizacao;
          return;
        }
      }
    };

    const transferir = async (value = "") => {
      if (value == "home") {
        router.push({ name: value });
        tab.value = value;
        localStorage.setItem("tab", tab.value);
        localStorage.setItem("subTab", "home");
        return;
      }
      router.push({ name: value });
      tab.value = value;
      localStorage.setItem("subTab", tab.value);
    };

    const getUnidades = async () => {
      const resposta = await store.dispatch("org/listarUnidades");
      store.dispatch("org/saveTodasUnidade", resposta.listaUnidades);
    };

    const getMenuUsuario = async () => {
      try {
        const response = await store.dispatch(
          "autenticacao/listarMenusForRouter"
        );

        if (response == undefined || response.length === 0) {
          return;
        }

        menuListaTotal.value = response;
        menuLista.value = response.filter((menu) => {
          return menu?.submenu?.nomeVisualizacao
            ?.toLowerCase()
            ?.normalize("NFD")
            ?.replace(/[\u0300-\u036f]/g, "")
            ?.includes(
              filtro.value
                ?.toLowerCase()
                ?.normalize("NFD")
                ?.replace(/[\u0300-\u036f]/g, "")
            );
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => filtro.value,
      () => {
        clearTimeout(menuSearchTimeout.value);

        menuSearchTimeout.value = setTimeout(() => {
          getMenuUsuario();
        }, 400);
      }
    );

    watch(
      () => store.state.idleVue.isIdle,
      () => {
        if (store.state.idleVue.isIdle) {
          myTimeout.value = setTimeout(() => {
            store.dispatch("autenticacao/logout");
            keycloak.logout({ redirectUri: window.location.origin });
          }, 60000);
        } else {
          clearTimeout(myTimeout.value);
        }
      }
    );

    const getButtonsHeader = async (name) => {
      router.push({ name: name });
    };

    const getNotificacoes = async () => {
      router.push({ name: "alt-listar" });
    };

    const getInico = async () => {
      router.push({ name: "home" });
    };

    const carregarVersaoAtual = async () => {
      const version = await fetchAppVersion({ useCacheBuster: true });
      versaoAtual.value = version || "--";
    };

    onMounted(async () => {
      await carregarVersaoAtual();
      await getMenuUsuario();
      getRelatorioCheck();
      getUnidades();
      getTab();
      verificarSubmenuPai();

      const email = usuarioLogado.value?.email;
      if (email) {
        const resultado = await avisoTreinamentoService.verificarTreinamento(
          email
        );
        if (resultado.acao === "exibirModal") {
          avisoTreinamentoDocId.value = resultado.docId || null;
          avisoTreinamentoUserSap.value = resultado.userSap || null;
          avisoTreinamentoUserName.value = resultado.userName || null;
          avisoTreinamentoTipoTreinamentoWeb.value =
            resultado.tipoTreinamentoWeb || null;
          avisoTreinamentoAberto.value = true;
        } else if (resultado.acao === "exibirModalCalendarioVencido") {
          avisoTreinamentoCalendarioVencidoDocId.value =
            resultado.docId || null;
          avisoTreinamentoCalendarioVencidoUserSap.value =
            resultado.userSap || null;
          avisoTreinamentoCalendarioVencidoUserName.value =
            resultado.userName || null;
          avisoTreinamentoCalendarioVencidoTipoTreinamentoWeb.value =
            resultado.tipoTreinamentoWeb || null;
          avisoTreinamentoCalendarioVencidoAberto.value = true;
        } else if (resultado.acao === "exibirModalVencido") {
          avisoTreinamentoVideosVencidoDocId.value = resultado.docId || null;
          avisoTreinamentoVideosVencidoUserSap.value =
            resultado.userSap || null;
          avisoTreinamentoVideosVencidoUserName.value =
            resultado.userName || null;
          avisoTreinamentoVideosVencidoTipoTreinamentoWeb.value =
            resultado.tipoTreinamentoWeb || null;
          avisoTreinamentoVideosVencidoAberto.value = true;
        }
      }
    });

    const perfisExibidos = computed(() => {
      const perfis = store.state.autenticacao.listaPerfis || [];
      return perfis.slice(0, 3);
    });

    return {
      leftDrawerOpen,
      routes,
      menuList,
      usuarioLogado,
      tabSubmenu,
      efetuarLogout,
      verNovidades,
      transferir,
      routerChildren,
      tab,
      getButtonsHeader,
      toggleLeftDrawerOpen,

      menuLista,

      menu,
      realm,
      getNotificacoes,
      getInico,
      filtro,
      favoritos,
      getTab,
      mobile,
      menuListaTotal,
      versaoAtual,
      perfisExibidos,
      avisoTreinamentoAberto,
      avisoTreinamentoDocId,
      avisoTreinamentoUserSap,
      avisoTreinamentoUserName,
      avisoTreinamentoTipoTreinamentoWeb,
      avisoTreinamentoCalendarioVencidoAberto,
      avisoTreinamentoCalendarioVencidoDocId,
      avisoTreinamentoCalendarioVencidoUserSap,
      avisoTreinamentoCalendarioVencidoUserName,
      avisoTreinamentoCalendarioVencidoTipoTreinamentoWeb,
      avisoTreinamentoVideosVencidoAberto,
      avisoTreinamentoVideosVencidoDocId,
      avisoTreinamentoVideosVencidoUserSap,
      avisoTreinamentoVideosVencidoUserName,
      avisoTreinamentoVideosVencidoTipoTreinamentoWeb,
    };
  },
};
</script>

<style scoped>
.titulos {
  padding-right: 10px;
}

.version-alert {
  position: fixed;
  z-index: 9999;
  right: 16px;
  bottom: 16px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px 10px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.version-alert:hover {
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.q-tabs--not-scrollable .q-tabs__content {
  justify-content: start !important;
  margin-left: 20px;
}

.separador {
  width: 100%;
  height: 3px;
  background-color: #ffffff !important;
}

.mobile {
  display: none;
}

.altura-minima {
  min-height: 0px !important;
}

.no-desktop {
  display: none;
}
.mobile-drawer {
  width: 30px;
}
@media (max-width: 1022px) {
  .mobile {
    display: flex !important;
  }

  .responsivo {
    display: none !important;
  }
}

@media print {
  .version-alert {
    display: none;
  }
}

@media (max-width: 600px) {
  .imagem-logo {
    display: none;
  }

  .btn-menu-aba {
    margin-right: 20px;
  }

  .no-mobile {
    display: none;
  }

  .no-desktop {
    display: flex;
    align-items: center;
  }

  .version-alert {
    font-size: 12px;
    right: 10px;
    bottom: 10px;
    padding: 4px 8px;
  }
}

.help {
  font-size: 12px;
}
.pointer {
  cursor: pointer;
}
.q-table__top {
  padding: 12px 0px !important;
}

/* Melhorias para botões responsivos do header */
.q-btn {
  transition: all 0.2s ease;
}

.q-btn:hover {
  transform: scale(1.05);
}

/* Garantir que tooltips apareçam corretamente */
.q-tooltip {
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.8);
}

/* Responsividade adicional para telas muito pequenas */
@media (max-width: 480px) {
  .q-toolbar .q-btn {
    min-width: 40px;
    padding: 4px 8px;
  }

  .q-toolbar .q-btn .q-icon {
    font-size: 18px;
  }
}
::v-deep .logo-ajustada .q-img__image {
  object-fit: contain !important;
}
</style>
